<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M25.457 24.153L21.218 19.8 5.658 35.829zM25.457 11.675L5.657 0l15.561 16.029zM32.005 20.134c1.341-1.044 1.341-3.398-.09-4.443L27.527 13.2l-4.897 4.714 4.897 4.715 4.479-2.495zM1.543 35.829L19.8 17.91 1.543.001V0C.619.476 0 1.343 0 2.47v30.888c0 1.127.62 1.994 1.543 2.47"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-google-play',
    props: {
      width: {
        type: [Number, String],
        default: 33
      },
      height: {
        type: [Number, String],
        default: 36
      },
      viewBox: {
        type: String,
        default: '0 0 33 36'
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
